<template>
    <div class="max-w-lg w-full mx-auto">

      <!-- Warning modal -->
      <div v-if="isWarningVisible" role="dialog" aria-modal="true" aria-labelledby="download-warning-title" aria-describedby="download-warning-description" @keydown.esc.stop.prevent="closeWarning" class="fixed inset-0 bg-gray-300 bg-opacity-75 flex items-center justify-center z-50">
        <div class="bg-white p-8 rounded-lg shadow-lg mx-5 md:w-1/3">
          <div class="flex items-center">
            <span aria-hidden="true" class="text-3xl pr-4">⚠️</span>
            <h2 id="download-warning-title" class="text-xl font-bold text-red-600">Before you download...</h2>
          </div>
          <p id="download-warning-description" class="mt-4 text-lg">We recommend downloading this file on a desktop or laptop computer, as the file size can be significantly large. To ensure a smooth and uninterrupted download, please make sure you are connected to a stable and high-speed internet connection.</p>
          <div class="mt-6 flex justify-between">
          <button ref="cancelDownload" @click="closeWarning" @keydown.shift.tab.prevent="$refs.confirmDownload.focus()" type="button" class="bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Cancel
          </button>
          <button ref="confirmDownload" @click="confirmWarning" @keydown.tab.exact.prevent="$refs.cancelDownload.focus()" type="button" class="bg-green-700 text-white py-2 px-4 rounded hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
            Download!
          </button>
        </div>
        </div>
      </div>


      <div :inert="isWarningVisible ? '' : null" class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
        <div class="mt-16 mx-auto max-w-7xl px-4 sm:mt-24 sm:px-6" v-if="this.errorMessage == null">
          <div class="text-center">
            <h1
              class="
                text-2xl tracking-tight font-black text-gray-900 sm:text-3xl
              "
            >
              <span class="block" 
                >Your Digital Download is ready!</span
              ><br/>
              <span class="block text-mygrad text-xl md:text-2xl"
                >Click the button below to download the film, and remember to store it somewhere safe! </span
              ><br/>
            </h1>
          </div>
        </div>
        <div class="mt-8 mx-auto py-3 max-w-7xl w-full" v-if="this.errorMessage == null">
          <div class="text-center w-full h-auto">
            <button
              ref="downloadTrigger"
              @click="openWarning"
              class="
               inline-flex items-center justify-center w-full px-4 py-2 border border-blue-300 shadow-sm text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500
              "
            >
              Download!
            </button>
          </div>
        </div>
        <div class="mt-8 mx-auto py-3 max-w-7xl w-full" v-else>
          <div role="status" class="text-center w-full h-auto">
            <h2
              ref="downloadStatus"
              tabindex="-1"
              class="
                text-2xl
                tracking-tight
                font-extrabold
                text-gray-900
                md:text-3xl
              "
            >
              <span class="block"
                >{{ errorMessage }}</span
              >
            </h2> 
          </div>
        </div>
         
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import {endSession, trackEvent} from "../../Analytics.vue";
  export default {
    name: "DigitalDownloadDelivery",
    props: {  },
    data : function() {
      return {
        errorMessage: null,
        isWarningVisible: false,
      }
    },
    watch: {
      errorMessage() {
        this.$nextTick(() => this.$refs.downloadStatus?.focus());
      },
    },
    methods: {
      openWarning() {
        this.isWarningVisible = true;
        this.$nextTick(() => this.$refs.cancelDownload.focus());
      },
      closeWarning() {
        this.isWarningVisible = false;
        this.$nextTick(() => this.$refs.downloadTrigger?.focus());
      },
      confirmWarning() {
        this.closeWarning();
        this.submit();
      },
      submit() {
        trackEvent(this.$route.path, {label: "DIGITAL_DOWNLOAD_COLLECT", digital_download_id: this.$route.params.id})

        axios({"method": "POST",
        "baseURL":  process.env.VUE_APP_DIGITAL_DOWNLOAD_BASE_URL,
        "url": "/download",
          "data": {
            digital_download_id: this.$route.params.id,
          }
        })
        .then((r) => {
          endSession();
          this.errorMessage = "Your download should start shortly - your browser will handle the rest!"
          window.location.href = r.data;
        })
        .catch((e) => {
           this.errorMessage = e.response.data.message;
        })
      },
    },
  };
  </script>
